<script lang="ts" setup>
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { IconSize } from '@consumer/components/GIcon.vue'
import type { ButtonSize, ButtonVariant } from './GButton.vue'

const { size = 'xsmall' } = defineProps<{
  icon: IconDefinition
  size?: ButtonSize
  iconSize?: IconSize
  label?: string
  secondary?: boolean
  variant?: ButtonVariant
  danger?: boolean
}>()
</script>

<template>
  <GButton
    class="icon-button"
    type="button"
    :color="secondary ? undefined : 'transparent'"
    :title="label"
    :name="label"
    :data-testid="label"
    :icon="icon"
    :size="size"
    :iconSize="iconSize"
    :secondary="secondary"
    :variant="variant"
    :danger="danger"
  />
</template>

<style lang="scss" scoped>
  .icon-button.g-button-secondary {
    --color: theme("colors.primary.base");
  }
</style>
